package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_02_02_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had recently defeated the Daveeds during the 4th watch of Newgrowth 40. The heroes continue their journey toward Zedj. They stop when they see a break in the plateau.  Caper collects some flowers for Entor.  The heroes investigate a cave which turns out to be a shrine of Doriath (a neutral aligned God commonly referred to as the “Ruler of Time”).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("While near the shrine, our heroes hear a familiar voice… Lalia says “so the party continues its travels.” Lalia wishes our heroes well and tells them they are headed in the right direction. [Lalia serves a devil who is at odds with a demon responsible for the demon incursion. She’s not a friend of the heroes, but their objectives and interests may briefly align.]")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During the 4th night watch, 4 Malusian Infantry soldiers on horseback ride past our heroes’ tiny hut. They inform the heroes that fiendish incidents have been reported in the towns before Zedj (Dunstom, Platville, and Cragton)as well as Zedj itself. Goram introduces himself as “12th Espionage Scout Brigade.”")
    }
}
